import React from 'react';
import logo from '../../assets/gifs/loading.gif';

export const Loading = (<div className="black-overlay" style={{backgroundColor: "rgba(21, 63, 86, 0.8)", position: "fixed"}}>
                            <div className="loadingClass">
                            </div>
                            <div className="loading-text">
                                <img src={logo} />
                            </div>
                        </div>);